module.exports = __webpack_public_path__ + "img/29.faff4572.svg";